import { render, staticRenderFns } from "./CambioNombreComercial.vue?vue&type=template&id=25b462e0&"
import script from "./CambioNombreComercial.vue?vue&type=script&lang=ts&"
export * from "./CambioNombreComercial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports